import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaVideoProps {
    name: string;
    description: string;
    thumbnailUrl: string | string[];
    uploadDate: string;
    contentUrl?: string;
    embedUrl?: string;
    duration?: string;
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    const path = url.startsWith("/") ? url : `/${url}`;
    return `${siteUrl}${path}`;
};

export function SeoSchemaVideo({
                                   name,
                                   description,
                                   thumbnailUrl,
                                   uploadDate,
                                   contentUrl,
                                   embedUrl,
                                   duration,
                               }: SeoSchemaVideoProps) {
    const siteUrl = getSiteUrl();

    const thumbnailUrls = Array.isArray(thumbnailUrl) ? thumbnailUrl : [thumbnailUrl];
    const thumbnails = thumbnailUrls.map((url) => toAbsoluteUrl(siteUrl, url));

    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "VideoObject",
        "name": name,
        "description": description,
        "thumbnailUrl": thumbnails,
        "uploadDate": uploadDate,
    };

    if (contentUrl) schema.contentUrl = toAbsoluteUrl(siteUrl, contentUrl);
    if (embedUrl) schema.embedUrl = toAbsoluteUrl(siteUrl, embedUrl);
    if (duration) schema.duration = duration;

    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
